import 'rxjs/add/observable/empty';

import { type Observable as ObservableType, Observable } from 'rxjs/Observable';
import { type OpenDetailViewAction, OPEN_DETAIL_VIEW } from '../../state/actions/detail-view';
import { clearMentionsOptimisticAction } from '../../state/actions/mentions';
import { getCards } from '../../state/selectors/cards';
import type { ActionsObservable, Action, MiddlewareAPI } from '../../state/types';

export function clearMentionsEpic(
	action$: ActionsObservable,
	store: MiddlewareAPI,
): ObservableType<Action> {
	return action$.ofType(OPEN_DETAIL_VIEW).switchMap((action: OpenDetailViewAction) => {
		const state = store.getState();
		const allCards = getCards(state);

		if (allCards[String(action.payload.cardId)]?.mentions) {
			return Observable.of(clearMentionsOptimisticAction(action.payload.cardId));
		}

		return Observable.empty();
	});
}
